import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { IProductFulfillmentAudit } from '@tpco/tpco-saturn-types';
import { sortFulfillmentAudit } from 'views/components/ProductFulfillments/ProductFulfillmentAuditConfig';

const LIST_PRODUCT_FULFILLMENT_AUDIT = gql`
  query ListProductFulfillmentsAudit($startDate: String, $getAll: Int) {
    productFulfillmentsAudit(startDate: $startDate, getAll: $getAll) {
      account_name
      campaign_name
      tgrams_id
      start_date
      end_date
      created_date
      opportunity_id
      campaign_id
      item_id
      product_id
      product_sku
      status_id
      quantity
      rank_points
      coverage_areas
      owner
      valid_region_points
    }
  }
`;

interface ProductFulfillmentListAuditContainerRenderProps {
  loading: boolean;
  productFulfillments: IProductFulfillmentAudit[];
}

interface ProductFulfillmentListContainerProps {
  startDate: string;
  getAll: number;
  activeSort: any;
  children: (props: ProductFulfillmentListAuditContainerRenderProps) => any;
}

const ProductFulfillmentListAuditContainer: React.FunctionComponent<
  ProductFulfillmentListContainerProps
> = ({ children, startDate, getAll, activeSort, ...props }) => {
  let query = LIST_PRODUCT_FULFILLMENT_AUDIT;

  return (
    <Query<any>
      query={query}
      variables={{ startDate: startDate, getAll: getAll }}
      fetchPolicy={'no-cache'}
    >
      {({
        data: { productFulfillmentsAudit } = {
          productFulfillmentsAudit: [] as IProductFulfillmentAudit[]
        },
        loading
      }) => {
        // if (loading) {
        //   return null;
        // }

        let productFulfillmentsAuditList: IProductFulfillmentAudit[] = [];
        if (productFulfillmentsAudit !== undefined) {
          productFulfillmentsAuditList = productFulfillmentsAudit;
        }
        return (
          children &&
          children({
            ...props,
            loading,
            productFulfillments: sortFulfillmentAudit(
              productFulfillmentsAuditList,
              activeSort.sortKey,
              activeSort.sortDirection
            )
          })
        );
      }}
    </Query>
  );
};

export default ProductFulfillmentListAuditContainer;
